import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
;
import { Button, Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;;
import { toast } from 'react-toastify';
import Masonry from 'react-masonry-component';
import { filter, uniqBy } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  setBreadcrumbs,
  ConfirmDeletionModal,
  reduceServerErrors,
  UiToastAdapter,
  InnerLoader,
  GuidelinesCard,
  // NextButton,
} from 'src/ui';
// import { getSettings } from 'src/auth';
import { getUser } from 'src/user';
import {
  getAccount,
  fetchAccount,
  deleteAccountDocument,
  deleteAccountDocumentType,
  fetchFormData,
  getFormData,
} from 'src/account';

import { getDocumentTypesForAccount } from '../services';
import { DocumentCard, AddDocumentTypeModal } from '../components';

const DocumentsListPage = ({
  setBreadcrumbs,
  fetchAccount,
  user,
  fetchFormData,
  deleteAccountDocument,
  deleteAccountDocumentType,
  account,
  formData,
}) => {
  const [loading, setLoading] = useState(true);
  const [deletingDocument, setDeletingDocument] = useState(null);
  const [archivingType, setArchivingType] = useState(null);
  const [documentCards, setDocumentCards] = useState([]);
  const [creatingDocument, setCreatingDocument] = useState(false);
  const [editTypeData, setEditTypeData] = useState(null);

  const guidelines = [
    `Here you will upload necessary documents for reference or review during the application process. Each section is labeled to show the documents needed for upload and can be in the form of .pdf, .docx, or various images if scanned.`,
    `An "Other" section has been provided if a document is requested that is not listed or if you have an additional document or image that you think is relevant to the application.`,
    `If you have any questions or need to include more than one additional document please contact support and we will assist you in this process.`,
  ];
  const reduceDocuments = () => {
    const { documents } = account;
    const documentTypes = getDocumentTypesForAccount(account, formData);

    const reducedDocumentCards = uniqBy(
      documentTypes.map(type => ({
        ...type,
        documents: filter(documents, { type: type.id }),
      })),
      'id'
    );
    setDocumentCards(reducedDocumentCards);
  };

  useEffect(() => {
    const fetchData = async () => {
      setBreadcrumbs([{ label: 'Documents', href: '/documents' }]);

      await fetchAccount(user.accountId);

      await fetchFormData(
        user.financialInstitutionId || account.financialInstitutions[0].id,
        user.accountId
      );

      let hasError = false;

      if (account.isError()) {
        reduceServerErrors(account);
        hasError = true;
      } else if (formData.isError()) {
        reduceServerErrors(formData);
        hasError = true;
      }

      if (!hasError) {
        reduceDocuments();
      }

      setLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!loading) {
      reduceDocuments();
    }
  }, [loading, account]);

  const onDelete = document => {
    setDeletingDocument(document);
  };

  const onCancelDelete = () => {
    setDeletingDocument(null);
  };

  const onConfirmDelete = async () => {
    setLoading(true);

    await deleteAccountDocument({
      accountId: user.accountId,
      documentId: deletingDocument.id,
    });
    setDeletingDocument(null);
    if (account.isError()) {
      reduceServerErrors(account);
    } else {
      toast(UiToastAdapter('Document deleted successfully!', 'success'));
    }

    setLoading(false);
    reduceDocuments();
  };

  const onArchiveType = type => {
    setArchivingType(type);
  };

  const onCancelArchiveType = () => {
    setArchivingType(null);
  };
  const onConfirmArchiveType = async () => {
    setLoading(true);

    await deleteAccountDocumentType({
      accountId: user.accountId,
      documentTypeId: archivingType.id,
    });
    setArchivingType(null);
    if (account.isError()) {
      reduceServerErrors(account);
    } else {
      toast(UiToastAdapter('Document Type archived successfully!', 'success'));
    }

    setLoading(false);
    reduceDocuments();
  };

  const onOpenAddDocumentType = () => {
    setCreatingDocument(true);
  };

  const onCloseAddDocumentType = () => {
    setCreatingDocument(false);
  };

  const onCloseEditDocumentType = () => {
    setCreatingDocument(false);
    setEditTypeData(null);
  };
  const onOpenEditDocumentType = data => {
    setCreatingDocument(true);
    setEditTypeData(data);
  };
  return (
    <>
      <Columns>
        <Column>
          <MuiTitle isSize="4" hasTextColor="info" tag="h2">
            Documents
          </MuiTitle>
        </Column>
        {user.isBankAdmin && (
          <Column isSize="narrow">
            <Button isColor="gradient-bright" onClick={onOpenAddDocumentType}>
              <span className="icon is-left">
                <FontAwesomeIcon icon={['fal', 'plus']} />
              </span>
              <span>Add Document Type</span>
            </Button>
          </Column>
        )}
      </Columns>
      <Columns>
        <Column>
          <Masonry className="columns">
            {documentCards.map(documentType => (
              <Column
                isSize="full"
                className="is-half-widescreen"
                key={documentType.id}
              >
                <DocumentCard
                  documentType={documentType}
                  onDeleteDocument={onDelete}
                  onOpenEditDocumentType={onOpenEditDocumentType}
                  isBankAdmin={user.isBankAdmin}
                />
              </Column>
            ))}
          </Masonry>
          <InnerLoader visible={loading} />
        </Column>
        {!user.isBankAdmin && (
          <Column isSize="narrow">
            <GuidelinesCard guidelines={guidelines} />
          </Column>
        )}
      </Columns>
      <ConfirmDeletionModal
        isActive={!!deletingDocument}
        onClickCancel={onCancelDelete}
        onClickConfirm={onConfirmDelete}
        title={deletingDocument ? deletingDocument.title : ''}
      />
      <ConfirmDeletionModal
        isActive={!!archivingType}
        onClickCancel={onCancelArchiveType}
        onClickConfirm={onConfirmArchiveType}
        title={archivingType ? archivingType.name : ''}
      />
      {user.isBankAdmin && (
        <AddDocumentTypeModal
          isActive={creatingDocument}
          account={account}
          onClose={
            editTypeData ? onCloseEditDocumentType : onCloseAddDocumentType
          }
          initialData={editTypeData}
          onArchiveType={onArchiveType}
          reduceDocuments={reduceDocuments}
        />
      )}
    </>
  );
};

DocumentsListPage.propTypes = {
  user: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
  formData: propTypes.object.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  fetchAccount: propTypes.func.isRequired,
  fetchFormData: propTypes.func.isRequired,
  deleteAccountDocument: propTypes.func.isRequired,
  deleteAccountDocumentType: propTypes.func.isRequired,
  // settings: propTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
    account: getAccount(state),
    formData: getFormData(state),
    // settings: getSettings(state),
  };
}

const connectedDocumentsListPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchAccount,
  fetchFormData,
  deleteAccountDocument,
  deleteAccountDocumentType,
})(DocumentsListPage);

export { connectedDocumentsListPage as DocumentsListPage };
